
import Home from './components/Home'
import Dashboard   from './components/Dashboard'
import Worklist from './components/Worklist'
import Login from "./components/Users/Login";
import OPDSpaceForMobile from "./components/OPDSpaceForMobile";
import ReportsDashboard from "./components/Admin/Reports/ReportsDashboard";
import Report001 from "./components/Admin/Reports/Report001";
import MainAdmin from "./components/Admin/MainAdmin/MainAdmin"
import ManuallyCreateLabAutomate from '../src/components/LABAutomate/ManuallyCreateLabAutomate/ManuallyCreateLabAutomate'
 
import master_data from "./store/modules/master_data";
import ImagesOfMonth from "./components/ImagesOfMonth/ImagesOfMonth"
import PathoItemsManagement from './components/Admin/PathoItemsManagement/PathoItemsManagement'
import PathoListOfJobServices from './components/PathoServices/PathoListOfJobServices' 
import PathoMemberDashboard from  './components/PathoMember/PathoMemberDashboard' 
import PathoInvoiceManager from './components/PathoServices/Invoice/PathoInvoiceManager'
//import PrepareMakeInvoice from './components/PathoServices/Invoice/PrepareMakeInvoice'
import PrepareMakeInvoice_SearchItems from './components/PathoServices/Invoice/PrepareMakeInvoice_SearchItems'
import PrepareMakeInvoice_Cart from './components/PathoServices/Invoice/PrepareMakeInvoice_Cart'
import LabNewsDetails from '../src/components/NewsV2/LabNewsDetails'  
// import WebLog1 from './components/Admin/WebLog1'
import DifferentialCounterLog from '../src/components/DifferentialCounter/DifferentialCounterLog'


/* eslint-disable no-unused-vars */
export const routes = [
    { path: '/', component: Home },
    { path: '/dashboard', component: Dashboard },
    { path: '/worklist', component: Worklist },
    { path: '/admin', component: MainAdmin },
    { path: '/login', component: Login ,
            beforeEnter: (to, from, next) => {
            if(to.path === '/login'){
                 // console.log('enter into login path  : '+ master_data.state.user_id)
                 if (master_data.state.user_id){
                      next(false)
                 }else{
                      next()
                 }
            }

     } },
    { path: '/reports', component: ReportsDashboard },
    { path: '/reports001', component: Report001 },
    { path: '/opdspaceformobile', component: OPDSpaceForMobile },

    { path: '/create_lab_automate', component: ManuallyCreateLabAutomate },
 

     
    { path: '/imagesofmonth', component: ImagesOfMonth }, 
    { path: '/pathoitemsmanagement', component: PathoItemsManagement }, 
    { path: '/patholistofjobservices', component: PathoListOfJobServices },  
    { path: '/pathomemberdashboard', component: PathoMemberDashboard },       
    { path: '/pathoinvoicemanager', component: PathoInvoiceManager },   
//     { path: '/preparemakeinvoice', component: PrepareMakeInvoice }, 
    { path: '/preparemakeinvoice_searchitems', component: PrepareMakeInvoice_SearchItems }, 
    { path: '/preparemakeinvoice_cart', component: PrepareMakeInvoice_Cart },  
    { path: '/labnewsdetails', component: LabNewsDetails },  

    { path: '/differentialcounterlog', component: DifferentialCounterLog },  
//     { path: '/weblog1', component: WebLog1 }, 

    // { path: '/temptest', component: Temptest },
  ];


